// According to the WebProcessingNodeComparator in the backend which was used the old way
const CATEGORY_PRIORITY = {
  Spatial: 1,
  Table: 2,
  Chart: 3,
  Report: 4,
  Chaining: 5,
  Condition: 5,
  Other: 5,
  NoCategory: 5
};

const RESULT_TABLE_TYPE = 'resulttable';

export function sortProcessings (processings) {
  if (!Array.isArray(processings)) {
    return processings;
  }
  return processings.sort(compareProcessings);
}

function compareProcessings (processingA, processingB) {
  return compareByCategory(processingA, processingB) || compareByPriorityOrName(processingA, processingB);
}

function compareByCategory (processingA, processingB) {
  return compare(CATEGORY_PRIORITY[processingA.category], CATEGORY_PRIORITY[processingB.category]);
}

/*
 * In desktop you can set priority for processings which can range from 1 to 50 (1 is higher priority)
 * For items that do not have set priority, value will be 0. But there is special case: resulttable
 * in the Table category should always be on top of that category.
 * So the order in category should be:
 * 1) Items with priority (lower priority value is higher priority)
 * 2) Items without priority
 * If some have same priority, (or in case no priority, then value is 0) they should be ordered
 * alphabetically. With exception: resulttable must be on top of Table category
 */
function compareByPriorityOrName (processingA, processingB) {
  if (processingA.type === RESULT_TABLE_TYPE) {
    return -1;
  } else if (processingB.type === RESULT_TABLE_TYPE) {
    return 1;
  }

  const priorityA = processingA.priority;
  const priorityB = processingB.priority;
  if (priorityA && priorityB) {
    return compare(priorityA, priorityB);
  } else if (priorityA && !priorityB) {
    return -1;
  } else if (priorityB && !priorityA) {
    return 1;
  } else {
    return compare(processingA.name, processingB.name);
  }
}

function compare (a, b) {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}
